import { OrderDto, OrderPaymentFrequency } from "Api/Api";
import { OrderDetailIconButton } from "Components/Orders/Detail/Styles";
import { EditIcon } from "Components/Shared/Icons";
import { Resources, useResource } from "Translations/Resources";
import { AppRouting, getPath } from "Utils/UrlUtils";
import { useNavigate } from "react-router";
import styled from "styled-components";

const StyledCopyIcon = styled(EditIcon)``;

type Props = {
  order: OrderDto;
};

export const CopyOrderIcon: React.FunctionComponent<Props> = props => {
  const { order } = props;
  const navigate = useNavigate();
  const { t } = useResource();

  //objednavka musi byt schvalena
  if (order.clientApprovedDate == null) {
    return;
  }
  // jenorazovou obejdnváku nelze editovat
  if (order.paymentFrequency === OrderPaymentFrequency.Single) {
    return;
  }

  //kdyz nema zadnou otevrenou polozku kalendare tak nelze editovat
  if (!order.hasAnyCreatedPaymentCalendarItem) {
    return;
  }

  if (order.areAllStepsCompleted) {
    return;
  }

  let disabledText = "";
  const anyActiveCopyOrder = order.copiedOrders.find(
    x => x.activeDateFrom !== null,
  );

  //neexistuje zadna kopie objednavky
  if (!!anyActiveCopyOrder) {
    disabledText = "Máte již novější verzi objednávky";
  } else if (order.copiedOrders.length > 0) {
    disabledText =
      "Máte již rozpracovanou editaci. Nejdříve ji musíte smazat, abyste mohli vytvořit novou.";
  } else if (order.hasPaymentCalendarItemAtSentToClient) {
    disabledText =
      "Smlouvu není možné editovat, protože se na ní nachází neuhrazená faktura. Je třeba fakturu uhradit nebo stornovat.";
  }
  const disabled = disabledText.length > 0;

  const handleClick = () => {
    if (!disabled) {
      navigate(getPath(AppRouting.OrderDetail, order.publicID, false, true));
    }
  };

  return (
    <>
      <OrderDetailIconButton
        onClick={handleClick}
        disabled={disabled}
        title={
          disabled ? disabledText : t(Resources.Orders.CopyOrderIcon.Tooltip)
        }
      >
        <StyledCopyIcon />
      </OrderDetailIconButton>
    </>
  );
};
